module.exports = __webpack_public_path__ + "static/media/barMenu.44174398.svg";